import { createRouter, createWebHistory } from "vue-router";
import HomePage from "./views/HomePage.vue";
import ChatPage from "./views/ChatPage.vue";
import ProblemPage from "./views/ProblemPage.vue";
import ToolsList from "./views/ToolsList.vue";

const routes = [
  {
    path: "/",
    name: "HomePage",
    component: HomePage,
  },
  {
    path: "/chat/:id",
    name: "ChatPage",
    component: ChatPage,
    props: true,
  },
  {
    path: "/problem/:id",
    name: "ProblemPage",
    component: ProblemPage,
    props: true,
  },
  {
    path: "/tools",
    name: "ToolsList",
    component: ToolsList,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
